///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewEncapsulation, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-root',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './app.component.html',
    styleUrls: [
        '../assets/themes/blueopal.css',
        '../../node_modules/bootstrap/dist/css/bootstrap.min.css',
        '../../node_modules/font-awesome/css/font-awesome.css',
        './app.css',
        './app.custom.css',
        './kendo.overrides.css',
    ],
})
export class AppComponent {}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/app.component.ts